import * as actionTypes from "./actionTypes";
import {
  getBenefitsForPlansAPI,
  deleteBenefitsForPlansAPI,
  createBenefitsForPlansAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    case "DUPLICATED_DATA":
      errorString = getLocalizedString("recognitionPlanAlreadyAssociatedWithSelectedBenefitType");
      break;
    case "IN_USE":
      errorString = getLocalizedString("itIsNotPossibleToDeleteTheRecordBecauseItIsInUse");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getBenefitsForPlansAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getBenefitsForPlansAPI();

    let data = response.data && response.data.data;
    let planList = response.data && response.data.planList;
    let benefitList = response.data && response.data.benefitList;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: { data, planList, benefitList },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const deleteBenefitsForPlansAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE });
  try {
    let response = await deleteBenefitsForPlansAPI(dataToSend);

    let data = response.data && response.data.data;
    let planList = response.data && response.data.planList;
    let benefitList = response.data && response.data.benefitList;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.DELETE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.DELETE_FULFILLED,
      payload: { data, planList,  benefitList },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("recordDeletedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DELETE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const createBenefitsForPlansAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE });
  try {
    let response = await createBenefitsForPlansAPI(dataToSend);

    let data = response.data && response.data.data;
    let planList = response.data && response.data.planList;
    let benefitList = response.data && response.data.benefitList;
    let conceptList = response.data && response.data.conceptList;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.CREATE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.CREATE_FULFILLED,
      payload: { data, planList, conceptList, benefitList },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("recordCreatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CREATE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};